<template>
  <AdaptiveSheet
    :opened="opened"
    @update:opened="$emit('update:opened', $event)"
    class="feed-comments-sheet"
    sheet-style="--f7-sheet-bg-color: #fff; --f7-sheet-height: 85vh;"
  >
    <f7-toolbar>
      <div class="left padding-left">
        <strong style="font-size: 13px;">{{ $t('feed.comments') }}</strong>
        <span v-if="commentsCount" class="fcs-count">({{ commentsCount }})</span>
      </div>
      <div class="right padding-right">
        <f7-link sheet-close popup-close><f7-icon f7="multiply" size="18" /></f7-link>
      </div>
    </f7-toolbar>

    <div v-if="reactionChips.length || repostsCount" class="fcs-reactions">
      <span
        v-for="chip in reactionChips"
        :key="chip.reactionType"
        class="fcs-chip"
        :title="chip.reactionType"
      >
        <span class="fcs-chip-emoji">{{ reactionEmoji(chip.reactionType) }}</span>
        <span class="fcs-chip-count">{{ chip.count }}</span>
      </span>
      <span v-if="repostsCount" class="fcs-chip" :title="$t('feed.reposts')">
        <f7-icon f7="repeat" size="13" />
        <span class="fcs-chip-count">{{ repostsCount }}</span>
      </span>
    </div>

    <f7-page-content class="fcs-scroll">
      <FeedCommentThread
        :comments="comments"
        :current-user-id="currentUserId"
        @react-comment="$emit('react-comment', $event)"
        @reply="$emit('reply', $event)"
        @load-more-replies="$emit('load-more-replies', $event)"
      />
      <div v-if="comments.length === 0" class="fcs-empty">
        <f7-icon f7="bubble_left" size="22" color="#c0c0c0" />
        <p>{{ $t('feed.beFirstToComment') }}</p>
      </div>
    </f7-page-content>

    <div class="fcs-composer">
      <FeedCommentComposer :placeholder="$t('feed.writeComment')" @submit="onComposerSubmit" />
    </div>
  </AdaptiveSheet>
</template>

<script setup>
import { computed } from 'vue'
import i18n from '../../js/i18n.js'
import { reactionEmoji } from '../../js/feedReactions.js'
import AdaptiveSheet from '../common/AdaptiveSheet.vue'

const { t } = i18n.global
import FeedCommentThread from './FeedCommentThread.vue'
import FeedCommentComposer from './FeedCommentComposer.vue'

const props = defineProps({
  opened:         { type: Boolean, default: false },
  comments:       { type: Array,   default: () => [] },
  commentsCount:  { type: Number,  default: 0 },
  reactions:      { type: Array,   default: () => [] },
  repostsCount:   { type: Number,  default: 0 },
  currentUserId:  { type: String,  default: '' },
})

const emit = defineEmits(['update:opened', 'comment', 'react-comment', 'reply', 'load-more-replies'])

const reactionChips = computed(() =>
  (props.reactions || []).filter((r) => (r.count || 0) > 0)
)

function onComposerSubmit(payload) {
  emit('comment', payload)
}
</script>

<style scoped>
.feed-comments-sheet {
  display: flex;
  flex-direction: column;
}
.fcs-count {
  font-size: 12px;
  font-weight: 400;
  color: var(--f7-on-surface-variant, #8e8e93);
}
.fcs-reactions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 12px;
  border-bottom: 0.5px solid var(--f7-list-item-border-color, #e0e0e0);
  flex-shrink: 0;
}
.fcs-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  /* background: var(--f7-list-bg-color, #f0f0f0);
  border: 0.5px solid var(--f7-list-item-border-color, var(--f7-list-item-border-color, #e0e0e0)); */
  border-radius: 14px;
  padding: 2px 9px;
  font-size: 11px;
  color: var(--f7-on-surface-variant, #8e8e93);
}
.fcs-chip-emoji { font-size: 13px; }
.fcs-chip-count { font-weight: 500; }
.fcs-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 10px 12px 4px;
}
.fcs-empty {
  text-align: center;
  padding: 26px 0;
  font-size: 12px;
  color: var(--f7-on-surface-variant, #8e8e93);
}
.fcs-empty p { margin-top: 8px; }
.fcs-composer {
  flex-shrink: 0;
  padding: 8px 12px;
  padding-bottom: calc(8px + var(--f7-safe-area-bottom, 0px));
  border-top: 0.5px solid var(--f7-list-item-border-color, #e0e0e0);
  background: var(--f7-page-bg-color, #fff);
}
</style>
